package org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.create_update_room


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Room

@Serializable
data class CashAssist(
    @SerialName("__typename")
    val typename: String?,
    @SerialName("updateRoom")
    val updateRoom: List<Room?>? = null,
    @SerialName("createRoom")
    val createRoom: Room? = null,
)